import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ClinicalTrialsExpanderComponent } from './components/clinical-trials-expander/clinical-trials-expander.component';
import { ClinicalTrialsUIComponent } from './components/clinical-trials-ui/clinical-trials-ui.component';
import { CompletenessComponent } from './components/completeness/completeness.component';
import { CriteriaFormComponent } from './components/criteria-form/criteria-form.component';
import { CriteriaComponent } from './components/criteria/criteria.component';
import { CriterionComponent } from './components/criterion/criterion.component';
import { ExpanderDirective } from './directives/expander.directive';
import { InformationalCriteriaComponent } from './components/informational-criteria/informational-criteria.component';
import { StopEventPropagationDirective } from './directives/stop-event-propagation.directive';
import { RemoveHyphenPipe } from './pipes/remove-hyphen.pipe';
import { TrialDetailsComponent } from '../lib/components/trial-details/trial-details.component';

const DECLARATIONS: any[] = [
  CompletenessComponent,
  ClinicalTrialsUIComponent,
  ClinicalTrialsExpanderComponent,
  CriteriaComponent,
  CriteriaFormComponent,
  CriterionComponent,
  ExpanderDirective,
  InformationalCriteriaComponent,
  RemoveHyphenPipe,
  StopEventPropagationDirective,
  TrialDetailsComponent,
];

@NgModule({
  declarations: [
    ...DECLARATIONS
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ...DECLARATIONS
  ]
})
export class ClinicalTrialsUIModule { }
